import { combineReducers } from "redux";
import counterReducer from "./slice/counter";
import homeReducer from "./slice/home";
import commonReducer from "./slice/common";
import categoryReducer from "./slice/category";
import cartReducer from "./slice/cart";
import authReducer from "./slice/auth";
import profileReducer from "./slice/profile";
import warrantyReducer from "./slice/warranty";
import eventReducer from "./slice/event";

export default combineReducers({
  counter: counterReducer,
  home: homeReducer,
  common: commonReducer,
  category: categoryReducer,
  cart: cartReducer,
  auth: authReducer,
  warranty: warrantyReducer,
  profile: profileReducer,
  event: eventReducer
});
